<app-base-layout [darkMode]="false" [showFooter]="true"
  ><!-- (keydown)="handleKeyboardEvent($event)" -->
  <form [formGroup]="formGroup" (ngSubmit)="changeStep()" class="form-next">
    <h1 class="form-next-title">{{ this.title }}</h1>
    <h2 class="form-next-description" [innerHTML]="this.description"></h2>

    <div *ngFor="let campo of campos; let first = first">
      <app-dynamic-input
        [requestFocus]="first"
        [campo]="campo"
        [form]="form"
        [formGroup]="formGroup"
        [isCepLoading]="isCepLoading"
        (onLoadingCep)="onLoadedCep($event)"
        class="dynamic-input"
      ></app-dynamic-input>

            <div *ngIf="campo.codigo === 'termo.aceite.token.sms'" class="resend-sms-container">
              <button
                type="button"
                class="btn-resend-sms"
                (click)="resendSms()"
                [disabled]="resendCooldown > 0 || isResendingSms"
              >
                <span *ngIf="!isResendingSms && resendCooldown === 0">
                  Reenviar novo token
                </span>
                <span *ngIf="!isResendingSms && resendCooldown > 0">
                  Aguarde {{ resendCooldown }}s para solicitar novo token
                </span>
                <span *ngIf="isResendingSms">
                  Reenviando...
                </span>
                <mat-spinner *ngIf="isResendingSms" diameter="16"></mat-spinner>
              </button>
            </div>

      <app-dependencies-group
        [campo]="campo"
        [form]="form"
        [formGroup]="formGroup"
      ></app-dependencies-group>
    </div>

    <mat-error *ngIf="hasEqualsPhonesError()">
      {{ getEqualsPhonesError() }}
    </mat-error>

    <div class="captcha-validating-message" *ngIf="captchaInvisible && captchaValidating">
      <mat-spinner diameter="20"></mat-spinner>
      <span>Por favor, aguarde...</span>
    </div>

    <div class="btn-avancar-container">
      <ngx-turnstile *ngIf="isValid() && captchaProvider === 'turnstile' && showCaptcha" 
      [siteKey]="captchaKey" 
      (resolved)="sendCaptchaResponse($event)" 
      (errored)="handleCaptchaError($event)"
      theme="auto" 
      [tabIndex]="0"
      [appearance]="captchaInvisible ? 'interaction-only' : 'always'"
      >
      </ngx-turnstile>
      <button
      class="btn-avancar" *ngIf="isValid() && !(captchaInvisible && captchaValidating)"
        type="submit"
        [disabled]="!isValid() || isSubmited || (showCaptcha && isRecaptchaOfTypeTurnstileAndInvalid())"
      >
      <div>
        Continuar
        <mat-icon aria-hidden="false" aria-label="Avançar"
          >navigate_next</mat-icon
        >
      </div>
      </button>
      <!-- <mat-spinner [class.hide]="!clickCheck ? true : false"  [diameter]="30" class="color-spinner"></mat-spinner> -->


    </div>
      
  </form>


</app-base-layout>
